import { Guid } from "@common/guid";
import { EntityType } from "@common/Common.types";
import { SearchResultViewModel } from "@common/components/search/SearchResultList.types";
import { ActivityFormProps } from "./ActivityForm.types";

export type ActivityRelationsSectionProps = Pick<ActivityFormProps, "model" | "onModelChange" | "readOnly">;

export function useActivityRelationsSection(props: ActivityRelationsSectionProps) {
    const relations = props.model.relations;

    function onAddRelation(relation: SearchResultViewModel) {
        if (relations.some((existing) => existing.entityId === relation.entityId)) {
            return;
        }

        const addedRelation = {
            entityId: relation.entityId,
            entityName: relation.entityName,
            entityType: relation.entityType,
            relationId: Guid.newGuid(),
            parentId: relation.parentId,
            subjectEntityType: relation.subjectEntityType,
            subjectEntityId: relation.subjectEntityId,
        };
        props.onModelChange({ relations: [...relations, addedRelation] });
    }

    function onRemoveRelation(relationId: string) {
        props.onModelChange({ relations: relations.filter((relation) => relation.relationId !== relationId) });
    }

    const visibleRelations = relations.filter((relation) => relation.entityType !== EntityType.User);

    return {
        visibleRelations,
        onAddRelation,
        onRemoveRelation,
    };
}
